const getArrayIntersection = (ary1, ary2) =>
  ary1.filter(value => ary2.includes(value));

export default getArrayIntersection;;